import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  searchPreviewText: {
    id: 'csm.chat.widget.search.trigger.search.preview.text',
    defaultMessage: 'Ask anything',
    description: 'Text for the preview version of CSM chat widget search trigger input'
  }
});